import React from "react";
import { Card, Button } from "antd";
import {
  PhoneOutlined,
  WifiOutlined,
  CreditCardOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const QuickActionsCard = () => {
  const navigate = useNavigate();
  return (
    <Card
      title="Quick Actions"
      className="border border-gray-300 rounded-lg shadow-md w-72 h-[266px]"
      style={{ background: "transparent" }}
    >
      <div className="grid grid-cols-2 gap-3">
        {/* Airtime Recharge */}
        <Button
          type="default"
          className="flex flex-col items-center justify-center w-full h-[80px] border border-gray-300 rounded-lg hover:bg-gray-100"
          onClick={() => navigate("/airtime")}
        >
          <PhoneOutlined className="mb-1 text-2xl text-blue-500" />
          <span className="text-xs font-medium">Airtime</span>
        </Button>

        {/* Data Recharge */}
        <Button
          type="default"
          className="flex flex-col items-center justify-center w-full h-[80px] border border-gray-300 rounded-lg hover:bg-gray-100"
          onClick={() => navigate("/data")}
        >
          <WifiOutlined className="mb-1 text-2xl text-green-500" />
          <span className="text-xs font-medium">Data</span>
        </Button>

        {/* Bills Payment */}
        <Button
          type="default"
          className="flex flex-col items-center justify-center w-full h-[80px] border border-gray-300 rounded-lg hover:bg-gray-100"
          onClick={() => navigate("/bills-payment")}
        >
          <CreditCardOutlined className="mb-1 text-2xl text-yellow-500" />
          <span className="text-xs font-medium">Bills</span>
        </Button>

        {/* Transfers */}
        <Button
          type="default"
          className="flex flex-col items-center justify-center w-full h-[80px] border border-gray-300 rounded-lg hover:bg-gray-100"
          onClick={() => navigate("/transfer")}
        >
          <SwapOutlined className="mb-1 text-2xl text-red-500" />
          <span className="text-xs font-medium">Transfers</span>
        </Button>
      </div>
    </Card>
  );
};

export default QuickActionsCard;
